import { usePostmongerContext } from '../../contexts/PostmongerContext';

import compose from '@hypnosphi/recompose/compose';
import { withStyles } from '@mui/styles';
import Paper from 'apollo-react/components/Paper';
import Loader from 'apollo-react/components/Loader';

import GenericNode from './GenericNode';

const styles = {
  paper: {
    maxWidth: 800,
    padding: 32,
    '& label': {
      marginBottom: 0,
    },
  },
  submit: {
    margin: '16px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  section: {
    marginBottom: 32,
  },
};

export const Generic = ({ classes }) => {

  const { 
    isLoading,
  } = usePostmongerContext();

    return (
        <Paper className={classes.paper}>
          {isLoading 
            ? (<Loader isInner />) 
            : (<GenericNode />)
          }
        </Paper>
  );
}

export default compose(
  withStyles(styles)
  )(Generic);
